export const menu = {
  menu_title: 'Resonance',
  // Header slot actions (ResonanceLayout)
  header_menu_aria: 'Menú',
  header_island_settings_aria: 'Ajustes de las islas',
  header_call_aria: 'Llamar al {{number}}',
  menu_logOut: 'Cerrar sesión',
  menu_language_button_text: 'Cambiar',
  menu_languages_modal_title: 'Elige tu idioma',
  menu_questionnaires_modal_title: 'Elige un cuestionario',
  menu_share_title: '{{appName}}',
  menu_share_text: 'Descubre {{appName}} 🙂',
  menu_share_link_copied: 'Enlace de invitación de {{appName}} copiado al portapapeles ✅',
  menu_share_not_supported: 'Compartir no está disponible en este dispositivo.',
  menu_share_link_error: 'No se puede generar un enlace de invitación por el momento.',
  menu_share_no_public_link: 'No hay ningún enlace de invitación público configurado.',
};
